import React, { memo, useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { changeProject, getProject } from '../../../redux/projects/projectsActions';
import { resetEditProjectPage } from '../../../redux/projects/projectsReducer';
import NameSection from '../name/NameSection';
import ShareSection from '../share/ShareSection';
import AccessUsersSection from '../access-users/AccessUsersSection';

import scss from './EditSonar.module.scss';

const EditSonar = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSaveNameSection = ({ id, editProject, values }) => {
    const { projectName, startingFromMonth, startingFromYear, rangeType, brand } = values;

    const startDate = `${startingFromYear}-${startingFromMonth}-01`;

    dispatch(
      changeProject({
        id,
        projectType: editProject.projectType,
        values: { projectName, formed: true, startDate, rangeType, brand },
      }),
    );
  };

  useEffect(() => {
    dispatch(getProject({ id }));

    return () => {
      dispatch(resetEditProjectPage());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <NameSection onSubmit={handleSaveNameSection} />
      <ShareSection />
      <AccessUsersSection />
    </div>
  );
};

export default memo(EditSonar);
